import { BASE_CONTEXT_V2_ROLEPLAY } from "../api-context";

export const SKILL_CATEGORY = {
    CREATE: `${BASE_CONTEXT_V2_ROLEPLAY}create_skill_category`,
    LIST: (bu: string, region: string) => `${BASE_CONTEXT_V2_ROLEPLAY}list_skill_categories?business_unit_code=${bu}&region_code=${region}`,
    UPDATE: (skill_category_id: number) => `${BASE_CONTEXT_V2_ROLEPLAY}update_skill_category/${skill_category_id}`,
}
